import { createAppTheme, Theme } from '@prometheus/components';

const DARK_BLUE = '#35174d';
const BLUE = '#41204f';
const DARK_GREY = '#474850';
const LIGHT_GREY = '#798395';

export let theme = createAppTheme({
  backgroundColor: {
    main: '#f5f3fa',
    dark: '#eeeef4',
    header: '#3a4451',
    icon: '#eeeef4',
  },
  primary: {
    dark: '#3b1a4d',
    main: '#7145a5',
    light: '#7145a5',
    contrastText: '#ffffff',
  },
  purple: {
    main: '#45A5A1',
  },
  info: {
    main: '#709dfe',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#adafd3',
    contrastText: '#ffffff',
  },
  success: {
    main: '#79d082',
    contrastText: '#ffffff',
  },
  error: {
    main: '#f33889',
    contrastText: '#ffffff',
  },
  borderColor: { main: '#cac3d2', light: '#f4f1f7' },
  textColor: {
    primary: DARK_BLUE, // dark blue
    secondary: DARK_GREY, // grey - text
    label: LIGHT_GREY, // light grey - text
    header: BLUE, // blue
  },
}) as Theme;
